export const valoresOffcanvas: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  codigoHexadecimal: 'Código Hexadecimal',
  nomeCor: 'Nome da Cor',
};

export const headersTable = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 5, key: 'id' },
  { text: 'Código Hex', width: 12, key: 'codigoHexadecimal' },
  { text: 'Nome da Cor', width: 15, key: 'nomeCor' },
  { text: 'Observações', width: 70, key: 'observacoes' },
];

export const fieldObjectOrgInters = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
